import React, { useCallback, useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Alert,
} from "reactstrap";

import { Swiper, SwiperSlide } from "swiper/react";
import classnames from "classnames";
import keepaImg from "../../assets/images/brands/keepa.png";
// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";

import { FreeMode, Navigation, Thumbs } from "swiper/modules";
import SwiperCore from "swiper";

import { Link } from "react-router-dom";
import moment from "moment";
import PlaceOrder from "./PlaceOrder";
import PricingWidgetList from "./PricingWidget";
import SalesChannels from "../../Components/Common/SalesChannels";
import RestrictedChannels from "../../Components/Common/RestrictedChannels";
import { formatCurrency } from "../../utils/Formater";
import { getLoggedinUser } from "../../utils/StorageManager";
import { useDispatch } from "react-redux";
import { setProductFlag } from "../../slices/thunks";
import { productStatusTypes } from "../../Components/constants/layout";
import UpgradeModal from "../../Components/Common/UpgradeModal";

SwiperCore.use([FreeMode, Navigation, Thumbs]);

const keepaFinderUrl = "https://keepa.com/#!finder";

const isKeepaUrl = (url) => {
  try {
    const { hostname, protocol } = new URL(url);
    return ["http:", "https:"].includes(protocol) &&
      (hostname === "keepa.com" || hostname.endsWith(".keepa.com"));
  } catch {
    return false;
  }
};

function ProductDetail(props) {
  const dispatch = useDispatch();
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [showPlaceOrder, setShowPlaceOrder] = useState(false);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [customActiveTab, setcustomActiveTab] = useState("1");
  const [products, setProducts] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showKeepaPreview, setShowKeepaPreview] = useState(false);
  const userProfileSession = getLoggedinUser();
  
  // Check if user has free trial
  const hasFreeTrialPlan = userProfileSession?.user_freeType === "trial";

  useEffect(() => {
    if (props.product) {
      setProducts(props.product);
    }
    return () => {
      setThumbsSwiper(null);
    };
  }, [props]);

  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  };

  const placeOrder = (product) => {
    if (hasFreeTrialPlan) {
      setShowUpgradeModal(true);
    } else {
      setSelectedProduct(product);
      setShowPlaceOrder(true);
    }
  };

  const toggle = useCallback(() => {
    if (props.show) props.onClose();
  }, [props.show]);

  const setFlag = (flag, state) => {
    if (!products) return;
    const data = { pro_id: products.pro_id, flagType: flag, state };
    dispatch(setProductFlag(data));
    // Optimistic UI update
    setProducts((prev) =>
      prev
        ? {
            ...prev,
            pro_isFavorite:
              flag === productStatusTypes.FAVORITE
                ? state
                : prev.pro_isFavorite,
            pro_isHidden:
              flag === productStatusTypes.HIDDEN ? state : prev.pro_isHidden,
            pro_stockAlert:
              flag === productStatusTypes.STOCKALERT
                ? state
                : prev.pro_stockAlert,
          }
        : prev
    );
  };

  const keepaLinkRenderer = (params) => {
    const isKeepaLink = isKeepaUrl(params?.pro_link);
    const keepaDestination = isKeepaLink ? params.pro_link : keepaFinderUrl;
    const openPopup = (e) => {
      e.preventDefault();
      window.open(
        keepaDestination,
        "keepaPopup",
        "width=1024,height=768,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=yes"
      );
    };

    const keepaPreviewUrl = isKeepaLink && products?.pro_ASIN
      ? `https://graph.keepa.com/pricehistory.png?domain=1&asin=${products.pro_ASIN}`
      : null;

    return (
      <center
        style={{
          position: "relative",
          display: "inline-flex",
          alignItems: "center",
          gap: "0.35rem",
        }}
      >
        <a
          href={keepaDestination}
          onClick={openPopup}
          onMouseEnter={() => isKeepaLink && setShowKeepaPreview(true)}
          onMouseLeave={() => setShowKeepaPreview(false)}
          className="d-inline-flex align-items-center gap-1"
        >
          <img alt={`keepa link logo`} src={keepaImg} className="logo" />
          <span className="fw-semibold text-muted">Keepa</span>
        </a>
        {showKeepaPreview && keepaPreviewUrl && (
          <div style={{
            position: "absolute",
            top: "110%",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 9999,
            background: "#fff",
            border: "1px solid #ccc",
            borderRadius: "4px",
            padding: "4px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
            whiteSpace: "nowrap",
          }}>
            <img
              src={keepaPreviewUrl}
              alt="Keepa price history"
              referrerPolicy="no-referrer"
              style={{ maxWidth: "300px", display: "block" }}
            />
          </div>
        )}
      </center>
    );
  };

  return (
    <>
      <UpgradeModal 
        isOpen={showUpgradeModal} 
        toggle={() => setShowUpgradeModal(false)} 
      />
      <PlaceOrder
        open={showPlaceOrder}
        selectedProduct={selectedProduct}
        onClose={() => setShowPlaceOrder(false)}
      />
      <Modal
        Modal
        isOpen={props.show}
        modalClassName="zoomIn"
        centered
        tabIndex="-1"
        fullscreen
      >
        <ModalHeader toggle={toggle} className="p-3 bg-primary-subtle">
          <div className="col-sm">
            <h5 className="card-title mb-0">Product Detail</h5>
          </div>
        </ModalHeader>
        <ModalBody>
          {products && (
            <Row>
              <Col lg={12}>
                <Card>
                  <CardBody>
                    <Row className="gx-lg-5">
                      {products?.pro_imageURLs && (
                        <Col xl={4} md={8} className="mx-auto">
                          <div className="product-img-slider sticky-side-div">
                            <Swiper
                              navigation={true}
                              thumbs={{ swiper: thumbsSwiper }}
                              className="swiper product-thumbnail-slider p-2 rounded bg-light"
                            >
                              <div className="swiper-wrapper">
                                {products?.pro_imageURLs
                                  .split(",")
                                  .map((subItem, key) => (
                                    <SwiperSlide>
                                      <img
                                        key={key}
                                        src={subItem}
                                        alt=""
                                        className="img-fluid d-block"
                                      />
                                    </SwiperSlide>
                                  ))}
                              </div>
                            </Swiper>

                            <div className="product-nav-slider mt-2">
                              <Swiper
                                onSwiper={setThumbsSwiper}
                                slidesPerView={4}
                                freeMode={true}
                                watchSlidesProgress={true}
                                spaceBetween={10}
                                className="swiper product-nav-slider mt-2 overflow-hidden"
                              >
                                <div className="swiper-wrapper">
                                  {products?.pro_imageURLs
                                    .split(",")
                                    .map((subItem, key) => (
                                      <SwiperSlide>
                                        <div className="nav-slide-item">
                                          <img
                                            key={key}
                                            src={subItem}
                                            alt=""
                                            className="img-fluid d-block"
                                          />
                                        </div>
                                      </SwiperSlide>
                                    ))}
                                </div>
                              </Swiper>
                            </div>
                          </div>
                        </Col>
                      )}

                      <Col xl={8}>
                        <div className="mt-xl-0 mt-5">
                          <div className="col-12 d-flex gap-1">
                            <Link
                              to={products?.pro_url}
                              className="text-body flex-grow-1"
                              target="_blank"
                            >
                              <h4>{products?.pro_name}</h4>
                            </Link>
                            <Button
                              outline
                              caret
                              size="sm"
                              onClick={() =>
                                setFlag(
                                  productStatusTypes.FAVORITE,
                                  !products?.pro_isFavorite
                                )
                              }
                            >
                              <i className="ri-heart-fill align-bottom me-2" />
                              {products?.pro_isFavorite
                                ? "Remove from favorites"
                                : "Mark as favorite"}
                            </Button>
                            <div className="vr"></div>
                            <Button
                              outline
                              caret
                              size="sm"
                              onClick={() =>
                                setFlag(
                                  productStatusTypes.HIDDEN,
                                  !products?.pro_isHidden
                                )
                              }
                            >
                              <i
                                className={
                                  products?.pro_isHidden
                                    ? "ri-eye-fill align-bottom me-2"
                                    : "ri-eye-off-fill align-bottom me-2"
                                }
                              />
                              {products?.pro_isHidden
                                ? "Unhide item"
                                : "Hide item"}
                            </Button>
                            {products?.pro_availableStock === 0 && (
                              <Button
                                outline
                                caret
                                size="sm"
                                onClick={() =>
                                  setFlag(
                                    productStatusTypes.STOCKALERT,
                                    !products?.pro_stockAlert
                                  )
                                }
                              >
                                <i className="ri-notification-fill align-bottom me-2" />
                                {products?.pro_stockAlert
                                  ? "Stop restock notifications"
                                  : "Notify me when this restocks"}
                              </Button>
                            )}
                          </div>
                          <div className="col-12 hstack gap-3 flex-wrap mt-2">
                            {keepaLinkRenderer(products)}
                            {products?.pro_packQuantity > 1 && (
                              <span className="badge rounded-pill bg-primary text-dark">
                                pack of {products?.pro_packQuantity}
                              </span>
                            )}

                            <div className="text-muted d-flex">
                              Vetted Channel(s) :{"  "}
                              <SalesChannels
                                channel={products?.pro_salesChannel}
                              />
                            </div>
                            <div className="text-muted d-flex">
                              Restricted Channel(s) :{" "}
                              <RestrictedChannels
                                channel={products?.pro_restrictedChannels}
                              />
                            </div>
                            <div className="vr"></div>
                          </div>

                          <div className="col-12 d-flex mt-2 gap-3 flex-wrap">
                            <div className="text-muted flex-warp">
                              Product codes :{" "}
                              <span className="text-body fw-medium">
                                <span>
                                  {products?.pro_UPCCode
                                    ? products?.pro_UPCCode
                                    : "No UPC Code"}
                                  {products?.pro_ASIN && (
                                    <span> / {products?.pro_ASIN}</span>
                                  )}
                                </span>
                              </span>
                            </div>
                            {products?.pro_SKU && (
                              <div className="text-muted flex-warp">
                                SKU :{" "}
                                <span className="text-body fw-medium">
                                  {products?.pro_SKU}
                                </span>
                              </div>
                            )}
                          </div>
                          <div className="vr"></div>
                          <div className="text-muted">
                            Published :{" "}
                            <span className="text-body fw-medium me-2">
                              {moment(products?.pro_dateAdded).format(
                                "MM/DD/YYYY, h:mm a"
                              )}
                            </span>
                            Last Updated :{" "}
                            <span className="text-body fw-medium">
                              {moment(products?.pro_lastModifiedDate).format(
                                "MM/DD/YYYY, h:mm a"
                              )}
                            </span>
                          </div>
                          {products?.pro_extendedLeadTime &&
                            products?.pro_extendedLeadTime > 0 && (
                              <div className="tooltip-icon fw-medium">
                                <i className="ri-time-line me-2 text-danger" />
                                <span className="fw-medium text-danger">
                                  Extended Lead Time:{" "}
                                  {products?.pro_extendedLeadTime} days
                                </span>
                              </div>
                            )}
                          {products?.pro_MAP > 0 && (
                            <div className="d-flex m-1">
                              <div className="flex-grow-1">
                                <span className="text-danger fw-medium">
                                  <p>
                                    This product is subject to minimum advertise
                                    pricing of{" "}
                                    {formatCurrency(products?.pro_MAP)} and
                                    cannot be sold on any sales channel below
                                    this price. By purchasing this product you
                                    agree to this terms.
                                  </p>
                                </span>
                              </div>
                            </div>
                          )}
                          {products?.pro_importantNotes &&
                            products?.pro_importantNotes != "" && (
                              <div className="d-flex m-1">
                                <div className="flex-grow-1">
                                  <span className="text-danger fw-medium">
                                    <p>
                                      Important notes:{" "}
                                      {products?.pro_importantNotes}
                                    </p>
                                  </span>
                                </div>
                              </div>
                            )}
                          {products?.imp_restrictedChannels && (
                            <div className="d-flex m-1">
                              <div className="flex-grow-1">
                                <span className="text-danger fw-medium">
                                  <p>
                                    This product cannot be sold on:{" "}
                                    <RestrictedChannels
                                      channel={
                                        products?.imp_restrictedChannels
                                          ? products?.imp_restrictedChannels
                                          : 0
                                      }
                                    />
                                  </p>
                                </span>
                              </div>
                            </div>
                          )}
                          {products != null && (
                            <>
                              <Row className="mt-4">
                                <PricingWidgetList
                                  pricingDetails={{
                                    icon: "ri-money-dollar-circle-fill",
                                    label: "Price",
                                    labelDetail: `${formatCurrency(
                                      products?.pro_price
                                    )}`,
                                  }}
                                />
                                <PricingWidgetList
                                  pricingDetails={{
                                    icon: "ri-stack-fill",
                                    label: "Min Order Quantity",
                                    labelDetail: `${products?.pro_minBuy}`,
                                  }}
                                />
                                <PricingWidgetList
                                  pricingDetails={{
                                    icon: "ri-stack-fill",
                                    label: "Max Order Quantity",
                                    labelDetail: `${products?.pro_maxBuy}`,
                                  }}
                                />
                              </Row>
                              <Row>
                                {products?.pro_availableStock > 0 && products?.pro_status == 0 && (
                                  <Col lg={3} sm={6}>
                                    <Button
                                      color="primary"
                                      className="mt-3"
                                      onClick={() => placeOrder(products)}
                                    >
                                      Place Order
                                    </Button>
                                  </Col>
                                )}
                                {products?.pro_availableStock == 0 && (
                                  <Col lg={3} sm={6}>
                                    <Alert color="danger">
                                      <div className="d-flex align-items-center">
                                        <i className="ri-alert-fill fs-20 me-2"></i>
                                        <div>
                                          <h5 className="mb-0">This product is out of stock</h5>
                                        </div>
                                      </div>
                                    </Alert>
                                  </Col>
                                )}
                              </Row>
                            </>
                          )}
                          <div className="product-content mt-5">
                            <Nav tabs className="nav-tabs-custom nav-success">
                              <NavItem>
                                <NavLink
                                  style={{ cursor: "pointer" }}
                                  className={classnames({
                                    active: customActiveTab === "1",
                                  })}
                                  onClick={() => {
                                    toggleCustom("1");
                                  }}
                                >
                                  Specification
                                </NavLink>
                              </NavItem>
                            </Nav>

                            <TabContent
                              activeTab={customActiveTab}
                              className="border border-top-0 p-4"
                              id="nav-tabContent"
                            >
                              <TabPane id="nav-speci" tabId="1">
                                <div className="table-responsive">
                                  <table className="table mb-0">
                                    <tbody>
                                      <tr>
                                        <th
                                          scope="row"
                                          style={{ width: "200px" }}
                                        >
                                          Category
                                        </th>
                                        <td>{products?.pro_categoryName}</td>
                                      </tr>
                                      <tr>
                                        <th scope="row">Brand</th>
                                        <td>{products?.pro_brand}</td>
                                      </tr>
                                      <tr>
                                        <th scope="row">Weight</th>
                                        <td>
                                          {products?.pro_shippingWeight}{" "}
                                          {products?.pro_shippingWeightUnit}
                                        </td>
                                      </tr>
                                      <tr>
                                        <th scope="row">Dimensions</th>
                                        <td>
                                          {products?.pro_dimLength} x{" "}
                                          {products?.pro_dimWidth} x{" "}
                                          {products?.pro_dimHeight}{" "}
                                          {products?.pro_dimUnit}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </TabPane>
                            </TabContent>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}
        </ModalBody>
        <div className="modal-footer">
          <Button
            color="secondary"
            variant="outline"
            onClick={toggle}
            className="btn "
          >
            Close
          </Button>
        </div>
      </Modal>
    </>
  );
}

export default ProductDetail;
